var _ = require('underscore');

module.exports = _;

_.microtime = function() {
	var now = new Date().getTime() / 1000;
	var s = parseInt(now, 10);
	return now;
};

_.objectGet = function(object, path) {
	var arr = _.isArray(path) ? path : (path || '').split('.');
	var cur = object;

	for (var i = 0, l = arr.length; i < l; i++) {
		if (!cur || (typeof cur[arr[i]] === 'undefined')) {
			return undefined;
		} else {
			cur = cur[arr[i]];
		}
	}

	return cur;
};

_.objectSet = function(object, path, value) {
	var arr = _.isArray(path) ? path : (path || '').split('.'), cur = object;

	for (var i = 0, l = arr.length - 1; i < l; i++) {
		if (!_.isObject(cur[arr[i]])) {
			cur[arr[i]] = {};
		}

		cur = cur[arr[i]];
	}

	if (!_.isEmpty(arr[i])) {
		cur[arr[i]] = value;
	}
	
	return true;
};

_.objectRemove = function(object, path) {
	var arr = _.isArray(path) ? path : (path || '').split('.'), cur = object;
	var last = arr.pop();

	if (arr.length) {
		if (!(cur = _.objectGet(object, arr))) {
			return true;
		}
	}
	
	delete cur[last];
	return true;
};

if (_.isUndefined(_._isObject)) {
	_._isObject = _.isObject;
}

_.isObject = function(arg) {
	return ((Object.prototype.toString.call(arg) === '[object Object]') || (Object.prototype.toString.call(arg) === '[object global]')) && !_.isUndefined(arg);
};

if (_.isUndefined(_._isEmpty)) {
	_._isEmpty = _.isEmpty;
}

_.isEmpty = function (arg) {
	if (_.isUndefined(arg) ||
		_.isNull(arg) ||
		_.isNaN(arg)) {
		return true;
	}

	if(_.isBoolean(arg)) {
		return !arg;
	}

	if (_.isString(arg)) {
		return ['false', '0', 'undefined'].indexOf(arg) !== -1 || arg.length === 0;
	}

	if (_.isFunction(arg) ||
		_.isRegExp(arg) ||
		_.isDate(arg)) {
		return false;
	}

	if (_.isObject(arg)) {
		return _._isEmpty(arg);
	}

	if (_.isArray(arg)) {
		return arg.length === 0;
	}

	if (_.isNumber(arg)) {
		return arg === 0;
	}
};

_.isSet = function (arg) {
	return !_.isUndefined(arg);
};

_.objectIsSet = function(object, path) {
	return _.isSet(_.objectGet(object, path));
};

//merge objects or arrays
//return new Array (not reference) if target === Array
_.merge = function() {
	var target = arguments[0];
	var args = Array.prototype.slice.call(arguments, 1).reverse();
	var current = args.pop();
	var checker;

	if (_.isObject(target)) {
		checker = _.isObject;
	} else {
		checker = _.isArray;
	}

	while (current) {
		if (!checker(current)) {
			throw new TypeError('Argument type differs from target');
		}

		if (_.isObject(target)) {
			for (var prop in current) {
				target[prop] = current[prop];
			}
		} else {
			target = target.concat(current);
		}

		current = args.pop();
	}

	return target;
};

//recursive merge objects or arrays
_.mergeRecursive = function() {
	var target = arguments[0];
	var args = Array.prototype.slice.call(arguments, 1).reverse();
	var current = args.pop(), i = 0;
	var checker;

	if (_.isObject(target)) {
		checker = _.isObject;
	} else {
		checker = _.isArray;
	}

	while (current) {
		if (!checker(current)) {
			throw new TypeError('Argument type differs from target');
		}

		for (var prop in current) {
			if (target[prop] && ((_.isArray(target[prop]) && _.isArray(current[prop])) ||  (_.isObject(target[prop]) && _.isObject(current[prop])) ) ) {
				target[prop] = _.mergeRecursive(target[prop], current[prop]);
			} else if (_.isObject(target)) {
				target[prop] = current[prop];
			} else {
				target.push(current[prop]);
			}
		}

		current = args.pop();
	}

	return target;
};

_.arrayUnique = _.uniq;

/**
 * Cut the string for a match at the beginning and at the end
 * @param  {String} str     [description]
 * @param  {String} pattern [description]
 * @return {String}         [description]
 */
_.trim = function(str, pattern) {
	if (!_.isString(str)) {
		return str;
	}

	if (!pattern  && String.prototype.trim) {
		return str.trim();
	}

	return str.replace(new RegExp('^[' + pattern + ']+', 'g'), '').replace(new RegExp('[' + pattern + ']+$', 'g'), '');
};

/**
 * Return string with upper first letter
 * @param  {String} str [description]
 * @return {String}     [description]
 */
_.upCharFirstLetter = _.ucfirst = function(str) {
	return str.slice(0, 1).toUpperCase() + str.slice(1);
};

_.toQueryString = function(obj, encode) {
	var str = [];

	(function rec(obj, prefix) {
		_.each(obj, function(item, key) {
			var p = prefix ? prefix + '[' + key + ']' : key;
			
			if (_.isObject(item) || _.isArray(item)) {
				rec(item, p);
			} else {
				str.push(p + '=' + (encode ? encodeURIComponent(item) : item));
			}

		});
	})(obj);
	
	return str.join('&');
};

//checkers


_.isNumeric = function (arg) {
	return !isNaN(parseFloat(arg)) && isFinite(arg) && (parseFloat(arg) == arg);
};

_.isHash = function(obj) {
	return _.isObject(obj) && _.isUndefined(obj.superclass);
};

_.arrayWithout = _.without;

_.inArray = _.contains;

_.getObjectKeys = Object.keys;

_.arrayRelation = function(obj, scope) {
	if (!obj) return false;
	
	if (obj._objClass === 'DataLayer') {
		return obj.getObjectValue(scope);
	} else if (obj._objClass === 'DataObject') {
		return obj.get(scope);
	}

	var tmp = scope.split('.'), last = tmp.pop();

	for (var i = 0; i < tmp.length; i++) {
		var name = tmp[i];

		if (_.isEmpty(obj)) return false;

		if (_.isArray(obj[name])) {
			obj = obj[name][0];

			if (!obj) return false;
		} else if (_.isObject(obj[name])) {
			if (obj[name].collection) {
				obj = _.clone(obj);
				_.merge(obj[name], _.toArray(obj[name].collection).shift());
			}

			if (obj[name]._objClass) {
				return obj[name].get(tmp.slice(i).join('.'));
			} else {
				obj = obj[name];
			}
		} else {
			return false;
		}
	}

	return obj[last];
};

_.removeArrayRow = _.without;
/**
 * Create clone
 * @param  {*} obj [description]
 * @return {*}     [description]
 */
_.clone = function(obj, recursive) {
	var clone, id;

	if ((_.isArguments(obj) || _.isArray(obj) && !recursive)) {
		return Array.prototype.slice.call(obj);
	} else if (_.isObject(obj)) {
		clone = {};
	} else if (_.isArray(obj)) {
		clone = [];
	} else  {
		return obj;
	}

	_.each(obj, function(val, key) {
		if (_.isString(key)) {
			clone[key] = recursive ? _.clone(val, true) : val;
		} else {
			clone.push(recursive ? _.clone(val, true) : val);
		}
	});

	return clone;
};

_.split = function(string, pattern, count) {
	var arr = string.split(pattern);

	if (!_.isSet(count) || (count > arr.length)) {
		return arr;
	}

	if (count <= 1) {
		return string;
	}

	var c = count - 1;

	var tail = arr.splice(c, arr.length - c);
	arr.push(tail.join(pattern));
	return arr;
};

_.getCallback = function(obj) {
	if (_.isFunction(obj)) {
		return obj;
	}

	if (_.isArray(obj) && obj.length === 2 && _.isString(obj[1])) {
		if (_.isObject(obj[0])) {
			if (_.isFunction(obj[0][obj[1]])) {
				return obj[0][obj[1]];
			}
		}
	}
	throw ('Invalid callback');
};


_.sortByField = function(arr, field) {
	return arr.sort(function(a, b) {
		if (a[field] < b[field]) {
			return -1;
		}

		if (a[field] > b[field]) {
			return 1;
		}

		return 0;
	});
};

_.isDl = function(obj) {
	return !_.isUndefined(obj) && obj._objClass === 'DataLayer';
};

_.mixin = function(obj) {
	for (var i = 1, l = arguments.length; i < l; i++) {
		for (var prop in arguments[i]) {
			if (!obj[prop]) {
				obj[prop] = arguments[i][prop];
			}
		}
	}

	return obj;
};

if (_.isUndefined(_._count)) {
	_._count = _.count;
}

_.count = function(obj) {
	switch (true) {
		case _.isDl(obj):
			return obj.getCount();
		case _.isArray(obj):
		case _.isString(obj):
			return obj.length;
		case _.isObject(obj):
			return _.getObjectKeys(obj).length;
	}

	return 0;
};

if (_.isUndefined(_._each)) {
	_._each = _.each;
}

_.each = function(object, callback, scope) {
	try {
		_._each(object, callback, scope);
	} catch (e) {
		if (e === '__fox_break_exception__') {
			return object;
		} else {
			_.exception(e, 'Caught each exception: ');
		}
	}

	return object;
};

/**
 * Return filtered data
 * @param  {(Array|Object|String)}   obj      [description]
 * @param  {Function} callback for collection item must return true to include in filtered collection
 * @return {(Object|Array|String)}            [description]
 */
if (_.isUndefined(_._filter)) {
	_._filter = _.filter;
}

_.filter = function(obj, callback) {
	var newObj = _.isObject(obj) ? {} : [];
	
	callback = callback || function (v) {return !_.isEmpty(v);};

	if (_.isObject(obj)) {
		for (var prop in obj) {
			if (callback(obj[prop])) {
				newObj[prop] = obj[prop];
			}
		}
	} else if (_.isArray(obj)) {
		newObj = obj.filter(callback);
	} else if (_.isString(obj)) {
		newObj = Array.prototype.filter.call(obj, callback).join('');
	}

	return newObj;
};

_.exception = function (error, msg) {
	if (!msg) {
		msg = 'Caught exception: ';
	}

	if (_.isString(error)) {
		return console.error(msg, error);
	}

	return console.error(msg, error.message, error.stack);
};

_.log = function(msg, printBacktrace, params) {
	/*if (typeof printBacktrace === 'undefined') {
		printBacktrace = false;
	}

	if (printBacktrace) {
		try {
			null();
		} catch (e) {
			var stack = this.parseStack(e.stack);
		}
	} else {
		var stack = [];
	}

	var timeDiff = this.microtime() - this.startTime;
	var niceTime = Math.floor(timeDiff) + String(timeDiff % 1).substring(1, 7);

	if (params) {
		console.log(niceTime + ' ----> ' + msg + ' %O' + stack.join("\n"), params || {});
	} else {
		console.log(niceTime + ' ----> ' + msg + stack.join("\n"));
	}*/
};

/**
* Multifunction extend method
* 1) Create class from object with auto generated void construtor
* 	var newClass = fox.extend({prop: 'someProp', method: function() {...some method...}})
*
* 2) Extend specified constructor function with object
*	-- var newClass = fox.extend(function() {...constructor...}, {prop: 'someProp', method: function() {...some method...}})
*		or
*	-- var newClass = function() {...constructor...}
*	-- fox.extend(newClass, {prop: 'someProp', method: function() {...some method...})
*
* 3) Create new class by extending parent class with object. NOTE: newClass will use parent's constructor in self scope.
*	-- var newClass = fox.extend({prop: 'someProp', method: function() {...some method...}}, parentClass)
*
* 4) Extend some class by another class
*	-- fox.extend(childClass, parentClass)
*	Now childClass has all parentClass's method and properties
*
* Also for 3 and 4 you can access all parent's overwritten methods using superclass:
* this.superclass.someParentMethod.apply(this, arguments)
*/

if (_.isUndefined(_._extend)) {
	_._extend = _.extend;
}

_.break = '__fox_break_exception__';

_.arrayRevageToValue = function (arr) {
	if (!_.isArray(arr)) return arr;

	var lastValue = arr[arr.length - 1];

	while (arr.length > 0 && (_.isUndefined(lastValue) || _.isNull(lastValue))) {
		arr.pop();

		lastValue = arr[arr.length - 1];
	}

	return arr;
};

_.genUniqueId = function(mask, regexp) {
	var defMask = 'xy';
	var defRegexp = /[xy]/g;
	var d = new Date().getTime();

	if (!_.isString(mask)) {
		mask = defMask;
	}

	if (!_.isRegExp(regexp)) {
		regexp = defRegexp;
	}

	return mask.replace(regexp, function(m) {
		var r = (d + Math.random() * 16) % 16 | 0;

		return (m === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
	});
};

_.callSuperMethod = function(method, args, superMethodName) {
	var args1 = [args[0], args[1], args[2], args[3], args[4], args[5]],
		scope = args1[5] ? args1[5] : this;
	
	args1[5] = scope.superclass;

	if (args1[5]) {
		if (_.inArray(scope._myProps, method)) {
			return args1[5][method].apply(this, args1);
		}

		return args1[5][superMethodName || 'callParent'].apply(this, [method, args1]);
	}
	
	return false;
};

_.defineProperty = function (name, value, desc) {
	if (!name) return this;

	desc = desc || {
		writable: false,
		value: value
	};

	if (!_.keys(desc).some(function (val) {return _.contains(['set', 'get', 'value'], val);})) {
		desc.value = value;
	}

	Object.defineProperty(this, name, desc);

	return this;
};

_.uniqid = _.uniqueId;

_.getStringSimpleHash = function (string, radix) {
	var hash = 5381;
	
	if (!_.isString(string)) return hash;

	var i = string.length;

	while(i) {
		hash = (hash * 33) ^ string.charCodeAt(--i);
	}

	hash = hash >>> 0;

	return _.isNumber(radix) ? hash.toString(radix) : hash;
};

_.isPromise = function (mbPromise) {
	return !fox.isNull(mbPromise) && typeof mbPromise === 'object' && _.isFunction(mbPromise.then);
}


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-helpers/index.js
// module id = 108
// module chunks = 0